module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Check-347c4e568054499641c236dffaa51c1a.svg";